import _ from '../../../utils/underscore';
import Store from '../../../utils/store';
import BaseObject from '../../../base/base_object';
import {PENDING_TOASTERS_KEY, DISPLAYED_TOASTERS_KEY} from '../toaster_service_consts';

class ToasterStorage extends BaseObject {
    static CLASS = "ToasterStorage";

	saveToDisplayed(toasterID) {
		let displayedQueue = this._getQueueFromStorage(DISPLAYED_TOASTERS_KEY);

		if (displayedQueue.indexOf(toasterID < 0)) {
			displayedQueue.push(toasterID);
		}
		Store.set(DISPLAYED_TOASTERS_KEY, JSON.stringify(displayedQueue));
	}

	saveToPending(toasterParams) {
		let pendingQueue = this._getQueueFromStorage(PENDING_TOASTERS_KEY);

		for (let i = 0; i < pendingQueue.length; i++) {
			if (pendingQueue[i].id === toasterParams.id) {
				// toasters already in message queue, no need to save it again
				this.logger.debug('TOASTER :: SAVE TO PENDING -> SAME ID FOUND ', toasterParams.id);
				return;
			}
		}

		pendingQueue.push(toasterParams);
		Store.set(PENDING_TOASTERS_KEY, JSON.stringify(pendingQueue));
	}

	getPendingToasters() {
		let i = 0,
			pendingQueue = this._getQueueFromStorage(PENDING_TOASTERS_KEY),
			displayedQueue = this._getQueueFromStorage(DISPLAYED_TOASTERS_KEY);

		while (i < pendingQueue.length) {
			// check whether the toast was displayed and remove it if so
			if (displayedQueue.indexOf(pendingQueue[i].id) >= 0) {
				pendingQueue.splice(i, 1);
				continue;
			}
			i++;
		}
		this.clear();

		this.logger.debug('TOASTER :: SHOWING SAVED TOASTERS ', pendingQueue);
		return pendingQueue;
	}

	clear() {
		Store.del(DISPLAYED_TOASTERS_KEY);
		Store.del(PENDING_TOASTERS_KEY);
	}

	_getQueueFromStorage(key, defaultValue = []) {
		let result = Store.get(key, null);
		return _.isNull(result) ? defaultValue : JSON.parse(result);
	}
}

export default ToasterStorage;